module.exports = __webpack_public_path__ + "img/location-plus.342fd38c.svg";